export const BOTTOM_ELEMENT_IDS = ["bottom-bar", "cta-list-container"];
